import { useStartTimeStorage } from '../../helpers';

export const useStartTimeChat = () => {
  const [_, { get, set }] = useStartTimeStorage();
  const time = new Date();
  const startTime = `${time.getHours()}:${
    (time.getMinutes() < 10 ? '0' : '') + time.getMinutes()
  }`;

  if (!get()) {
    set(startTime);
  }

  return startTime;
};
